var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#C2C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6697 9.25C7.34883 9.25 6.1742 9.88776 5.42636 10.8775C5.26541 11.0905 5.18493 11.197 5.18756 11.341C5.1896 11.4522 5.25943 11.5925 5.34693 11.6611C5.46019 11.75 5.61714 11.75 5.93104 11.75H11.4084C11.7223 11.75 11.8792 11.75 11.9925 11.6611C12.08 11.5925 12.1498 11.4522 12.1518 11.341C12.1545 11.197 12.074 11.0905 11.913 10.8775C11.1652 9.88776 9.99056 9.25 8.6697 9.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6697 8C9.70523 8 10.5447 7.16053 10.5447 6.125C10.5447 5.08947 9.70523 4.25 8.6697 4.25C7.63416 4.25 6.7947 5.08947 6.7947 6.125C6.7947 7.16053 7.63416 8 8.6697 8Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/profile-avatar.f3f7521dd0312b75cb033d5dd8e08fc0.svg";
export { ForwardRef as ReactComponent };